import { render, staticRenderFns } from "./Marquees.vue?vue&type=template&id=213a5cce&scoped=true"
import script from "./Marquees.vue?vue&type=script&lang=js"
export * from "./Marquees.vue?vue&type=script&lang=js"
import style0 from "./Marquees.vue?vue&type=style&index=0&id=213a5cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213a5cce",
  null
  
)

export default component.exports